var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useContext, useState } from 'react';
import { ApiContext } from '../context';
export function useApiMutation(params) {
    const mutationApiHelpers = useMutationApiHelpers();
    const [mutating, { registerMutation, deregisterMutation }] = useIsMutating();
    const mutate = (...mutationArgs) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        registerMutation();
        const mutator = params.mutation(...mutationArgs);
        let returnValue;
        try {
            returnValue = yield mutator(mutationApiHelpers);
        }
        catch (error) {
            if (params.onError) {
                return params.onError(error, { mutationArgs });
            }
            throw error;
        }
        finally {
            deregisterMutation();
        }
        (_b = (_a = params).onSuccess) === null || _b === void 0 ? void 0 : _b.call(_a, returnValue, { mutationArgs });
    });
    return [mutate, { mutating }];
}
function useIsMutating() {
    const [numOccurringMutations, setNumOccurringMutations] = useState(0);
    return [
        numOccurringMutations > 0,
        {
            registerMutation: () => setNumOccurringMutations((prev) => prev + 1),
            deregisterMutation: () => setNumOccurringMutations((prev) => prev - 1)
        }
    ];
}
function useMutationApiHelpers() {
    const { api, defaults: { useApiMutation: { fetchPolicy: defaultFetchPolicy } } } = useContext(ApiContext);
    /**
     * Same as `api.request` but uses default fetch policy from context
     */
    const _request = (params, options = {}) => {
        return api.request(params, Object.assign(Object.assign({}, options), { fetchPolicy: options.fetchPolicy || defaultFetchPolicy }));
    };
    return {
        request: _request,
        requestInProgress: api.requestInProgress,
        readCachedResponse: api.readCachedResponse,
        writeCachedResponse: api.writeCachedResponse,
        buildUrl: api.buildUrl,
        setDefaultHeader: api.setDefaultHeader,
        baseUrl: api.baseUrl
    };
}
//# sourceMappingURL=index.js.map